<agpr-dialog-container
    [id]="'wireCreateDialog'"
    [heading]="'Amplify.dialogs.newWire.heading'"
    [modal]="true"
    [draggable]="false"
    [contentPadding]="false"
    (close)="closeDialog()"
>
    <div class="content">
        <div class="content-message">{{ 'Amplify.wire.paMedia.message' | localize }}</div>
        <div class="content-disclaimer">{{ 'Amplify.wire.paMedia.disclaimer' | localize }}</div>
    </div>
    <ng-template #footerLeft>
        <agpr-button
            [label]="'Core.button.cancel'"
            [id]="'wireCreateDialog.cancelButton'"
            (click)="closeDialog()"
        >
        </agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            [id]="'wireCreateDialog.createButton'"
            label="Amplify.wire.paMedia.button"
            (click)="createClicked()"
        >
        </agpr-button>
    </ng-template>
</agpr-dialog-container>